import Vue from 'vue';
import Router from 'vue-router';

import Admin from '@/Admin';
import Login from '@/components/Login';
import Dashboard from '@/components/Dashboard';
import PasswordReset from '@/components/PasswordReset';
import Opportunity from '@/components/Opportunity';

Vue.use(Router);

export default new Router({
	routes: [
		{
			path: '/', name: '', component: Admin,
			children: [
				{path: '/dashboard', name: 'dashboard', component: Dashboard, meta: {}},
				{path: '/login', name: 'login', component: Login, meta: {}},
				{path: '/reset-password/:token', name: 'reset-password', component: PasswordReset, meta: {}},
				{path: '/opportunities/:id', name: 'opportunity', component: Opportunity, meta: {}}
			]
		}
	]
});
